import { render, staticRenderFns } from "./ModalBroadcastCompany.vue?vue&type=template&id=bbef64aa&"
import script from "./ModalBroadcastCompany.vue?vue&type=script&lang=ts&"
export * from "./ModalBroadcastCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports